import React, { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgIconWeight: React.FC<PropsType> = ({ color, style }) => {
  const iconFillColor = color || '#292929';
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
    >
      <path
        d='M8.85763 18.625C8.4358 18.625 8.07713 18.4773 7.78163 18.1818C7.48613 17.8863 7.33838 17.5276 7.33838 17.1058V6.89425C7.33838 6.47242 7.48613 6.11375 7.78163 5.81825C8.07713 5.52275 8.4358 5.375 8.85763 5.375H12.1999C13.219 5.375 14.1405 5.69233 14.9644 6.327C15.788 6.9615 16.1999 7.816 16.1999 8.8905C16.1999 9.63783 16.0194 10.2471 15.6584 10.7182C15.2975 11.1894 14.9088 11.5314 14.4921 11.7442C15.005 11.9211 15.4947 12.2708 15.9614 12.7933C16.428 13.3158 16.6614 14.0192 16.6614 14.9038C16.6614 16.1819 16.1902 17.1217 15.2479 17.723C14.3055 18.3243 13.3562 18.625 12.3999 18.625H8.85763ZM9.48838 16.6328H12.3191C13.1063 16.6328 13.6627 16.4142 13.9884 15.977C14.314 15.5398 14.4769 15.1206 14.4769 14.7192C14.4769 14.3179 14.314 13.8987 13.9884 13.4615C13.6627 13.0243 13.0909 12.8058 12.2729 12.8058H9.48838V16.6328ZM9.48838 10.875H12.0826C12.6903 10.875 13.172 10.7013 13.5279 10.3538C13.8835 10.0064 14.0614 9.59042 14.0614 9.10575C14.0614 8.59042 13.8733 8.16925 13.4971 7.84225C13.1208 7.51542 12.6595 7.352 12.1134 7.352H9.48838V10.875Z'
        fill={iconFillColor}
      />
    </svg>
  );
};

export default SvgIconWeight;
